import { doc, getDoc } from '@/lib/firestore'
import { db } from '@/config/firebase'

interface VoiceConfig {
  tunnelUrl: string
  tunnelToken: string
}

let cachedConfig: VoiceConfig | null = null

async function getVoiceConfig(): Promise<VoiceConfig> {
  if (cachedConfig) return cachedConfig

  const snap = await getDoc(doc(db, 'copilotSettings', 'voice'))
  if (!snap.exists()) throw new Error('Voice config not found')

  const data = snap.data()
  cachedConfig = {
    tunnelUrl: data.tunnelUrl,
    tunnelToken: data.tunnelToken,
  }
  return cachedConfig
}

export function clearVoiceConfigCache() {
  cachedConfig = null
}

export async function synthesizeSpeech(text: string, language = 'es', format: 'text' | 'md' = 'text'): Promise<Blob> {
  const config = await getVoiceConfig()

  const res = await fetch(`${config.tunnelUrl}/tts`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${config.tunnelToken}`,
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': '1',
    },
    body: JSON.stringify({ text, language, format }),
  })

  if (!res.ok) {
    const errText = await res.text().catch(() => '')
    throw new Error(`TTS error ${res.status}: ${errText}`)
  }

  return res.blob()
}
